import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from 'src/components/PageTitle';
import { OutfitCollectionForm } from 'src/modules/collections/components/outfit-collection/OutfitCollectionForm.jsx';
import { OutfitCollectionCollapsibles } from 'src/modules/collections/components/outfit-collection/OutfitCollectionCollapsibles.jsx';
import { textFrom } from 'src/utils/textFrom';
import { BackButton } from 'src/components/BackButton';
import { Routes } from 'src/router/Routes.helper';
import { useHistory } from 'react-router-dom';
import { CollectionsAPI } from '../../api/CollectionsAPI';
import { useOutfits } from 'src/modules/outfits/provider/outfits.provider';
import { message } from 'antd';
import { useOutfitCollections } from '../../provider/outfitCollections.provider';
import { DefaultButton } from 'src/components/buttons/DefaultButton';
import { SubmitButton } from 'src/components/buttons/SubmitButton';

export const PageEditOutfitCollection = () => {
  const { t } = useTranslation();
  const text = textFrom('pages.collections.outfitCollection/edit', t);

  const [linkedOutfits, setLinkedOutfits] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { outfits } = useOutfits();
  const { outfitCollectionDetail } = useOutfitCollections();

  const history = useHistory();

  useEffect(() => {
    if (outfitCollectionDetail) {
      setLinkedOutfits(outfitCollectionDetail.linkedOutfits ?? []);
    }
  }, [outfitCollectionDetail]);

  const navigateToOutfitCollection = () => {
    history.push(Routes.PATHS.OUTFIT_COLLECTION);
  };

  const onFinish = async (preparedPayload) => {
    const outfitCollectionPayload = { ...preparedPayload };
    setIsLoading(true);
    try {
      const res = await CollectionsAPI.upsertCollection(outfitCollectionPayload);
      const collectionId = res?.data?.id;
      if (collectionId) {
        const bulkSetPayload = linkedOutfits.map(outfit => outfit.id);
        await CollectionsAPI.bulkSetLinkedOutfitsToOutfitCollection(collectionId, bulkSetPayload);
        message.success(text('collectionUpdatedOK'));
        navigateToOutfitCollection();
      } else {
        message.error(text('collectionUpdatedKO'));
      }
    } catch (e) {
      message.error(text('somethingWentWrong'));
    } finally {
      setIsLoading(false);
    }
  };

  const buttons = (
    <div className='flex w-full mt-20'>
      <DefaultButton
        label={text('cancel')}
        onClick={navigateToOutfitCollection}
        className='ml-auto mr-4'
      />
      <SubmitButton
        loading={isLoading}
        disabled={isLoading}
        label={text('save')}
      />
    </div>
  );

  return (
    <div className='py-4'>
      <PageTitle>{text('pageTitle')}</PageTitle>
      <BackButton
        iconChevron
        className='mt-4 mb-8'
        onClick={navigateToOutfitCollection}
        title={text('backButton')}
      />
      <OutfitCollectionForm
        outfitCollection={outfitCollectionDetail}
        onFinish={onFinish}
        buttons={buttons}
      >
        <OutfitCollectionCollapsibles
          outfits={outfits}
          linkedOutfits={linkedOutfits}
          setLinkedOutfits={setLinkedOutfits}
        />
      </OutfitCollectionForm>
    </div>
  );
};
